import(/* webpackMode: "eager", webpackExports: ["LuminousAnimationCard","LuminousAnimationHandler"] */ "/vercel/path0/apps/web/src/layouts/institucional/Elements/LuminousAnimation/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Benefits/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/CTA/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Elements/Text/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/HowItWorks/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/privacy/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/next-bricks/dist/index.js");
